import * as ko from 'knockout';

import {PropertyControl} from "../PropertyControl";

import Template from './Template.html';
import {ProductPropertyDescription} from "../../ProductPropertyDescription";
import { ProductPart } from "../../../ProductPart";
import { PropertyValue } from '../../../PropertyValue';

export class TextPropertyControl extends PropertyControl {
    private _displayValue: KnockoutObservable<string>;

    constructor(property: ProductPropertyDescription, productPart: ProductPart) {
        super(property, productPart);

        this.HasContent = ko.observable(true);
        this._displayValue = ko.observable(null);
        this.SetIsReady();
    }

    get MaxInputLength() {
        return this.Size > 0 ? this.Size : -1;
    }

    GetTemplate() {
        return Template;
    }

    GetValueForSave(): any {
        if (this._displayValue()) {
            return this._displayValue();
        }
        return null;
    }

    SetValue(propertyValue: PropertyValue) {
        if (propertyValue) {
            this._displayValue(propertyValue.Value);
        }
        this.StartListeningValueChanges();
    }

    UpdateValue(value: string) {
        this.SetValue(new PropertyValue(0,value, this.IsValid(value)))
    }

    ClearValue() {
        this._displayValue(null);
    }

    private StartListeningValueChanges() {
        if (this._displayValue.getSubscriptionsCount() == 0) {
            this._displayValue.subscribe(() => {
                this.CheckValidControl();
                this.OnValueChanged();
            });
        }
    }

    IsValid(value?: any): boolean {
        const valueToCheck = value ? value : this.GetValueForSave();
        return this.GetIsRequiredValidation(valueToCheck) && this.GetSizeValidation(valueToCheck);
    }

    CheckValidControl() {
        this.isValidControl(this.GetIsRequiredValidRule(this.GetValueForSave()) && this.GetIsSizeValidRule(this.GetValueForSave()));
    }
}